import React from "react";
import Radium from "radium";
import EventListener from "react-event-listener";
import _ from "lodash";

import {
  RaisedButton,
  Checkbox,
  RadioButton,
  RadioButtonGroup,
  Toggle
} from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../../../stores/EventBucketStore";
import EventBucketActions from "../../../actions/EventBucketActions";
import LedgerActions from "../../../actions/LedgerActions";
import LedgerStore from "../../../stores/LedgerStore";
import UserStore from "../../../stores/UserStore";

import WorkingIndicator from "../working-indicator.jsx";
import Label from "../label.jsx";

import moment from "moment";
import twix from "twix";

import * as util from "../../../util";
import config from "../../../config";

class BoxOfficeReportView extends React.Component {
  constructor(props) {
    super(props);

    this.downloadCsv = this.downloadCsv.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
  }

  static getStores() {
    return [EventBucketStore, LedgerStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getLedgerAnalyticsTransactions:
        LedgerStore.getLedgerAnalyticsTransactions,
      getLedgerBoxOfficeTransactions:
        LedgerStore.getLedgerBoxOfficeTransactions,
      getLedgerBoxOfficeReport: LedgerStore.getLedgerBoxOfficeReport,
      isFetching: LedgerStore.getState().isFetching
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      newProps.selectedBucket === null ||
      newProps.selectedFilms.length === 0
    ) {
      return;
    }

    if (
      newProps.selectedBucket !== this.props.selectedBucket ||
      !_.isEqual(newProps.selectedFilms, this.props.selectedFilms) ||
      force === true
    ) {
      const conditions = this.buildConditions(newProps);
      const options = {
        timePeriod: newProps.grouping
      };

      LedgerActions.fetchLedgerBoxOfficeReport.defer({
        conditions,
        options
      });

      if (newProps.selectedBucket !== newProps.selectedBucket) {
        EventBucketActions.fetchOne.defer(newProps.selectedBucket);
      }
    }
  }

  buildConditions(newProps) {
    const timezone = newProps.getEventBucketById(newProps.selectedBucket)
      .timezone;

    let conditions = Object.assign({
      event_bucket: [newProps.selectedBucket]
    });

    if (!newProps.allTime) {
      conditions.date = {
        $gt: moment.tz(newProps.startTime, timezone).startOf("day"),
        $lte: moment.tz(newProps.endTime, timezone).endOf("day")
      };
    }

    //TODO: Discuss with Theo about these values in the Box Office Report
    conditions["type"] = { $in: ["PAYMENT", "ADJUSTMENT", "REFUND"] };
    conditions["class"] = { $in: ["TICKET", "TAX"] };
    conditions.films = newProps.selectedFilms.map(item => {
      if (item.value) {
        return item.value;
      } else {
        return item;
      }
    });

    return conditions;
  }

  downloadCsv() {
    const conditions = this.buildConditions(this.props);
    const options = {
      timePeriod: this.props.grouping,
      format: "csv"
    };

    const form = document.createElement("form");
    form.method = "post";
    form.action = `${
      config.endpoint
    }analytics/box_office_report?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;
    form.target = "generatedCsv";

    document.body.appendChild(form);

    window.open("", "generatedCsv");
    form.submit();
  }

  downloadPdf() {
    const conditions = this.buildConditions(this.props);
    const options = {
      timePeriod: this.props.grouping,
      format: "pdf"
    };

    const form = document.createElement("form");
    form.method = "post";
    form.action = `${
      config.endpoint
    }analytics/box_office_report?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;
    form.target = "generatedPdf";

    document.body.appendChild(form);

    window.open("", "generatedPdf");
    form.submit();
  }

  getStyles() {
    return {
      overlay: {
        position: "absolute",
        right: 0,
        top: 0,
        backgroundColor: "#fff",
        boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
        zIndex: 1
      },
      overlaySubmit: {
        position: "absolute",
        right: 10,
        bottom: 10
      },
      gridHeaderRow: {
        color: "#fff",
        backgroundColor: "#0288d1"
      },
      gridHeaderLabel: {
        textAlign: "right",
        padding: "4px",
        width: "100px",
        borderRight: "1px solid #fff"
      },
      gridDayTitle: {
        fontWeight: "bold",
        fontSize: "16px",
        paddingTop: "20px",
        paddingBottom: "2px",
        paddingLeft: "2px"
      },
      gridTimeTitle: {
        fontWeight: "bold",
        fontSize: "13px",
        paddingTop: "2px",
        paddingLeft: "2px",
        paddingBottom: "2px"
      },
      gridLabelCell: {
        textAlign: "left",
        padding: "2px"
      },
      gridDataCell: {
        textAlign: "right",
        padding: "2px",
        width: "100px"
      },
      gridButtonRow: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "start"
      }
    };
  }

  render() {
    const styles = this.getStyles();

    const {
      selectedBucket,
      selectedFilms,
      allTime,
      startTime,
      endTime
    } = this.props;

    const eventBucket = this.props.getEventBucketById(selectedBucket);

    let timePeriod = allTime
      ? "All time"
      : moment(startTime)
          .twix(endTime, { allDay: true })
          .format({ implicitYear: false });

    let displayArray = [];

    if (selectedBucket && selectedFilms && selectedFilms.length > 0) {
      displayArray = this.props.getLedgerBoxOfficeReport();
    }

    return (
      <div>
        {!this.props.isFetching ? (
          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                paddingTop: "20px"
              }}
            >
              <table>
                <tbody>
                  <tr style={styles.gridHeaderRow}>
                    <td></td>
                    <td style={styles.gridHeaderLabel}>SALES</td>
                    <td style={styles.gridHeaderLabel}>REFUNDS</td>
                    <td style={styles.gridHeaderLabel}>ADMITS</td>
                    <td style={styles.gridHeaderLabel}>GROSS TOTAL</td>
                    <td style={styles.gridHeaderLabel}>FEE TOTAL</td>
                    <td style={styles.gridHeaderLabel}>TAX TOTAL</td>
                    <td style={styles.gridHeaderLabel}>NET TOTAL</td>
                  </tr>
                  {displayArray.length > 0 ? (
                    displayArray.map(row => {
                      if (row.time === undefined && row.summary === undefined) {
                        return (
                          <tr>
                            <td colSpan="8" style={styles.gridDayTitle}>
                              {row.description}
                            </td>
                          </tr>
                        );
                      } else if (row.time && row.category === undefined) {
                        return (
                          <tr>
                            <td colSpan="8" style={styles.gridTimeTitle}>
                              {row.description}
                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr
                            style={
                              row.summary === undefined
                                ? {}
                                : row.overall
                                ? {
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    borderBottom: "1px solid black"
                                  }
                                : {
                                    fontWeight: "bold",
                                    fontSize: "13px",
                                    borderBottom: "1px solid black"
                                  }
                            }
                          >
                            <td
                              style={
                                row.overall
                                  ? { paddingTop: "20px", paddingLeft: "2px" }
                                  : styles.gridLabelCell
                              }
                            >
                              {row.description}
                            </td>
                            <td style={styles.gridDataCell}>{row.saleCount}</td>
                            <td style={styles.gridDataCell}>
                              {row.refundCount}
                            </td>
                            <td style={styles.gridDataCell}>
                              {row.admitCount}
                            </td>
                            <td style={styles.gridDataCell}>
                              {row.grossTotal}
                            </td>
                            <td style={styles.gridDataCell}>{row.feeTotal}</td>
                            <td style={styles.gridDataCell}>{row.taxTotal}</td>
                            <td style={styles.gridDataCell}>{row.netTotal}</td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {displayArray.length > 0 ? (
              <div style={styles.gridButtonRow}>
                <div style={styles.rangeContainer}>
                  <RaisedButton
                    style={{ marginTop: "20px", marginRight: "25px" }}
                    onClick={this.downloadCsv}
                    label="DOWNLOAD (.CSV)"
                  />
                </div>
                <div style={styles.rangeContainer}>
                  <RaisedButton
                    style={{ marginTop: "20px", marginRight: "25px" }}
                    onClick={this.downloadPdf}
                    label="DOWNLOAD (.PDF)"
                  />
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <div style={{ clear: "both" }}>
            <WorkingIndicator fullPage={true} />
          </div>
        )}
      </div>
    );
  }
}

export default Radium(connectToStores(BoxOfficeReportView));



// WEBPACK FOOTER //
// ./src/app/components/partials/report-views/box-office-report-view.jsx